import { render } from "./FeaturedInfo.vue?vue&type=template&id=78df97e3&scoped=true"
import script from "./FeaturedInfo.vue?vue&type=script&lang=js"
export * from "./FeaturedInfo.vue?vue&type=script&lang=js"

import "./FeaturedInfo.vue?vue&type=style&index=0&id=78df97e3&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78df97e3"]])

export default __exports__